import { Link } from "react-router-dom";
import type { Work } from "@/types";

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={work.cover}
          alt={`${work.title}海报`}
          title={`${work.title} - 杨幂影视作品`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-label bg-primary-500 text-background-50">
          {work.type}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-[11px] font-label bg-foreground-950/70 text-background-50 backdrop-blur">
          {work.year}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {work.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 line-clamp-1">
          饰 {work.role}
        </p>
        <p className="mt-1 text-xs text-secondary-600 line-clamp-1">导演 {work.director}</p>
      </div>
    </Link>
  );
}